module.exports = __webpack_public_path__ + "img/huace5.f7b6029c.jpg";